module.exports = __webpack_public_path__ + "media/swoosh2.b38ff053.ogg";